import { render, staticRenderFns } from "./SingleList.vue?vue&type=template&id=0ca2227b&lang=pug&"
import script from "./SingleList.vue?vue&type=script&lang=js&"
export * from "./SingleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports